import ServiceCard from "./ServiceCard";
import React, { useRef, useEffect } from "react";
import styled, { keyframes, css } from "styled-components";
import "../App.css";

const servicesData = [
  {
    id: 1,
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/d8c1f42e82fdd24250269831e8b71bf177fdbdeb9182c1a68a18effdb53628ab?placeholderIfAbsent=true&apiKey=af3b926ef0c2405e9a702a855cd6e35e",
    title: "Compensation Plans",
    description:
      "<span class='span-bold span-dark'>Custom compensation plans tailored to your business needs.</span> Get a plan that perfectly fits your company, product, demographics, and goals. <span class='span-dark'>Maximum results without breaking the bank.</span>",
    variant: "blue",
  },
  {
    id: 2,
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/d8c1f42e82fdd24250269831e8b71bf177fdbdeb9182c1a68a18effdb53628ab?placeholderIfAbsent=true&apiKey=af3b926ef0c2405e9a702a855cd6e35e",
    title: "Business Plan",
    description:
      "<span class='span-bold span-dark'>Ready to go Direct Sales?</span> <span class='span-dark'>We'll assess if your product is MLM-ready and provide a complete roadmap.</span> <span class='span-bold'>Our comprehensive services establish your sales channel quickly and effectively.</span>",
  },
  {
    id: 3,
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/d8c1f42e82fdd24250269831e8b71bf177fdbdeb9182c1a68a18effdb53628ab?placeholderIfAbsent=true&apiKey=af3b926ef0c2405e9a702a855cd6e35e",
    title: "Go Global",
    description:
      "<span class='span-bold span-dark'>Strategic global expansion when the time is right.</span> Our experts guide you through necessary legal, commission and operational adaptations for new markets. <span class='span-bold'>Access global opportunities with confidence.</span>",
  },
  {
    id: 4,
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/d8c1f42e82fdd24250269831e8b71bf177fdbdeb9182c1a68a18effdb53628ab?placeholderIfAbsent=true&apiKey=af3b926ef0c2405e9a702a855cd6e35e",
    title: "MLM Software",
    description:
      "<span class='span-bold span-dark'>Powerful MLM software solutions for your business.</span> Get exactly what you need to manage your direct sales operation efficiently. <span class='span-bold'>Technology that scales with your growing network.</span>",
  },
  {
    id: 5,
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/d8c1f42e82fdd24250269831e8b71bf177fdbdeb9182c1a68a18effdb53628ab?placeholderIfAbsent=true&apiKey=af3b926ef0c2405e9a702a855cd6e35e",
    title: "Best MLM Speakers",
    description:
      "<span class='span-bold span-dark'>Access the industry's top motivational talent.</span> Direct selling thrives on great coaching and personal development. <span class='span-bold'>We connect you with the best speakers and coaches in the business.</span>",
  },
  {
    id: 6,
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/d8c1f42e82fdd24250269831e8b71bf177fdbdeb9182c1a68a18effdb53628ab?placeholderIfAbsent=true&apiKey=af3b926ef0c2405e9a702a855cd6e35e",
    title: "Coach Sessions",
    description:
      "<span class='span-bold span-dark'>Targeted coaching for startups and established businesses.</span> Our tailored sessions help you build, launch or accelerate growth. <span class='span-bold'>Protect your business while maximizing its potential.</span>",
  },
];

function Services() {
  const gridRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const gridPosition = gridRef.current.getBoundingClientRect().top;
      const screenPosition = window.innerHeight;

      if (gridPosition < screenPosition) {
        const cards = gridRef.current.querySelectorAll(".service-card");
        cards.forEach((card, index) => {
          card.style.animation = `floatIn 1s ease forwards ${index * 0.2}s`;
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <ServicesWrapper id="services">
      <Header>
        <TitleWrapper>
          <Icon
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/518c6eee96c39124b7a29ca5a3c147b481304ff8a623356a4438999677d98c04?placeholderIfAbsent=true&apiKey=af3b926ef0c2405e9a702a855cd6e35e"
            alt=""
          />
          <SectionLabel>Our Services</SectionLabel>
        </TitleWrapper>
        <SectionTitle>How can we help you</SectionTitle>
      </Header>
      <ServicesGrid ref={gridRef}>
        {servicesData.map((service) => (
          <ServiceCard key={service.id} {...service} />
        ))}
      </ServicesGrid>
    </ServicesWrapper>
  );
}

const ServicesWrapper = styled.section`
  background-color: rgba(2, 73, 95, 1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: Manrope, sans-serif;
  padding: 120px 80px;
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 70% 20%, rgba(25, 116, 145, 0.7), rgba(2, 73, 95, 1) 70%);
    z-index: 0;
  }
  
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    opacity: 0.1;
    z-index: 0;
  }

  @media (max-width: 991px) {
    padding: 100px 20px;
  }
`;

const Header = styled.div`
  display: flex;
  width: 585px;
  max-width: 100%;
  flex-direction: column;
  font-weight: 400;
  position: relative;
  z-index: 1;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 16px;
  color: rgba(255, 255, 255, 1);
  text-transform: uppercase;
  letter-spacing: 1.92px;
`;

const Icon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  width: 20px;
`;

const SectionLabel = styled.span`
  color: #fff;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 0;
    width: 100%;
    height: 2px;
    background: var(--accent-color);
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }
  
  ${TitleWrapper}:hover &:after {
    transform: scaleX(1);
  }
`;

const SectionTitle = styled.h2`
  color: #fff;
  font-size: 48px;
  line-height: 1.4;
  margin-top: 14px;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  position: relative;
  
  @media (max-width: 991px) {
    font-size: 40px;
  }
`;

const ServicesGrid = styled.div`
  display: flex;
  margin-top: 60px;
  width: 100%;
  max-width: 1240px;
  align-items: start;
  gap: 30px;
  line-height: 1.4;
  flex-wrap: wrap;
  align-self: center;
  position: relative;
  z-index: 1;
  
  @media (max-width: 991px) {
    margin-top: 40px;
  }
`;

export default Services;
